/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-case-declarations */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable eqeqeq */
/* eslint-disable no-debugger */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import { motion } from 'framer-motion';
import React, {
    useEffect, useState, useRef, useCallback, useContext,
} from 'react';
import { connect } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import { UserActions } from '../../redux/actions/user.action';
import { userService } from '../../service/user.service';
import TableHeader from '../../TableHeader';
import CustomToast from '../../Components/AlertPopup';
import ItemSkeleton from '../../Components/Skeletons/itemSkeleton';
// import FilterModal from './FilterModal';
import Pagination from '../../Components/Pagination';
import HeaderContext from '../../Components/Context/HeaderContext';
// import ListOffers from './ListOffers';
import { DApActions, DistributorActions } from '../../redux/actions';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import { distributorService } from '../../service/distributor.service';
import ListDap from './ListDap';
import { DapService } from '../../service/dap.service';
import FilterModal from './FilterModal';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function ManageDap({
    getDAPList, DAPList, SortUser, handlePagination, AdminUserPagination,
}) {
    const [isPaneOpen, setisPaneOpen] = useState(false);
    const [NoUser, setNoUser] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [isLoaded, setisLoaded] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [EditDAte, setEditDAte] = useState([]);
    const [editpaneopen, seteditpaneopen] = useState(false);
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [sort, setsort] = useState(false);
    const [sortType, setsortType] = useState('created_at+desc');
    const [alertShow, setalertShow] = useState(false);
    const [linksentPopup, setlinksentPopup] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [nextPageHasData, setnextPageHasData] = useState(false);
    const [filter, setfilter] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [showPopup, setshowPopup] = useState(false);
    const [renderPage, setrenderPage] = useState(false);
    const [render, setrender] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [color, setcolor] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [isEditId, setisEditId] = useState('');

    const [selected, setselected] = useState({
        destination_type: [],
        industrial_pocket: [],
        status: '',
        start_date: '',
        end_date: '',
    });
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);
    const ref = useRef();
    /**
     * it will open sidebar modal
     */
    const handleOpen = () => {
        setisPaneOpen(true);
    };
    /**
     * Fetching user list
     */
    const [TempPage, setTempPage] = useState(0);
    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setisLoaded(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setisLoaded(true);
    }, [currentPage, sortType]);

    const handleFetch = useCallback((() => {
        // const page = handlePageValue();
        getDAPList(currentPage, debouncedSearch, filterValue, sortType).then((val) => {
            if (!val.error && val.data.success_status) {
                setHardRefresh(false);
                if (val.data.data.LastEvaluatedKey !== undefined) {
                    DapService.DAPList(val.data.data.LastEvaluatedKey.account_id, debouncedSearch, filterValue, sortType).then((resp) => {
                        if (resp?.data?.data?.Items.length > 0) {
                            setnextPageHasData(true);
                            setNoUser(false);
                            setisLoaded(false);
                            setfilter(false);
                        } else {
                            setNoUser(true);
                            setisLoaded(false);
                            setnextPageHasData(false);
                        }
                    });
                } else {
                    setfilter(false);
                    setisLoaded(false);
                    setnextPageHasData(false);
                }
            } else {
                SetErrorMessage(val.message);
                setHardRefresh(false);
                setcolorValue(true);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }
            setisLoaded(false);
        });
    }), [currentPage, debouncedSearch, filterValue, sortType]);

    const handleFiletr = (url) => {
        if (filterValue !== url) {
            setisLoaded(true);
            setCurrentPage(1);
            setfilterValue(url);
        } else {
            setfilter(false);
            setfilterValue(url);
        }
    };
    const handleExport = useCallback((() => {
        DapService.handlePolicyExport(currentPage, debouncedSearch, filterValue, sortType, exportSelected).then((val) => {
            if (val.data.success_status) {
                setshowPopup(true);
                settitle(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 2000);
            }
        });
    }), [exportSelected]);

    const handleActivateOrDeactivate = (status, code) => {
        setactvloader(true);
        const payload = {
            admin_status: String(status),
        };
        const action = status === 'Active' ? 'deactivate' : 'activate';
        DapService.policyActiveOrDeactivateAccount(action, code).then((res) => {
            if (!res.error && res.data.success_status) {
                setOpenPopup('');
                setactvloader(false);
                setisLoaded(true);
                settitle(res.data.message);
                setshowPopup(true);
                setTimeout(() => {
                    setshowPopup(false);
                }, 4000);
                handleFetch();
            } else {
                setactvloader(false);
            }
        });
    };

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const [threePL, setthreePL] = useState([]);
    const [territaryList, setterritaryList] = useState([]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };
    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }
    const handleClickOutside = (event) => {
        if (exportClick) {
            setexportClick(false);
        }
    };
    const handlePage = () => {
        let isNextPage = true;
        if (currentPage === 1 && DAPList?.list.length < 7) {
            isNextPage = false;
        }
        return isNextPage;
    };

    const previlegeassigned = AccessPrevilegesFunction('dap:create');
    const viewdapprevilegeassigned = AccessPrevilegesFunction('dap:view');
    const updatedapprevilegeassigned = AccessPrevilegesFunction('dap:update');
    const activatedeactivedapprevilegeassigned = AccessPrevilegesFunction('dap:activate' || 'dap:deactivate');

    return (
        <>
            {
                showPopup && (
                    <CustomToast
                        open
                        color={color ? '#ED1C24' : undefined}
                        message={<OtpSuccessMeessage />}
                    />
                )
            }

            <TableHeader
                setsearchValue={setsearchValue}
                searchValue={searchValue}
                filter={filter}
                setfilter={setfilter}
                setexportSelected={setexportSelected}
                exportClick={exportClick}
                exportSelected={exportSelected}
                setexportClick={setexportClick}
                setisEditId={setisEditId}
                list={DAPList.list}
                setCurrentPage={setCurrentPage}
                previlegeassigned={previlegeassigned}
            />

            <div
                className="dropdown-menu sticky overflow-auto top-[0px] left-0"
                style={{ height: 'calc(100vh - 298px)' }}
                onClick={() => handleClickOutside()}
            >

                {!isLoaded
                    ? (
                        <>
                            {DAPList?.list.length > 0
                                && (
                                    <table className="w-full table-auto relative">

                                        <motion.thead
                                            animate={{ opacity: 1, x: 0 }}
                                            initial={{ opacity: 0, x: -10 }}
                                            exit={{ opacity: 0, x: -10 }}
                                            transition={{ duration: 0.15 }}
                                            className="sticky top-[0px] left-0 z-[2]"
                                            style={{ zIndex: OpenPopup || exportClick ? '99' : '99' }}
                                        >
                                            <tr className="bg-[#555259] h-10">
                                                <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg sticky top-0 left-0 bg-[#555259]" scope="col" style={{ minWidth: '180px' }}>
                                                    <span className="text-xs5 font-bold flex justify-start text-[#FFFFFF]">
                                                        Policy Name
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Ship From
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center" style={{ minWidth: '150px' }}>
                                                        Destination Type
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-1 px-1  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Freight Charges
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'dap_charges+asc' ? 180 : 0,
                                                                }}
                                                                // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'dap_charges+asc') {
                                                                        setsortType('dap_charges+desc');
                                                                    } else if (sortType === 'dap_charges+desc') {
                                                                        setsortType('dap_charges+asc');
                                                                    } else {
                                                                        setsortType('dap_charges+asc');
                                                                    }
                                                                    setCurrentPage(1);
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[140px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Status
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'policy_status+asc' ? 180 : 0,
                                                                }}
                                                                // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'policy_status+asc') {
                                                                        setsortType('policy_status+desc');
                                                                    } else if (sortType === 'policy_status+desc') {
                                                                        setsortType('policy_status+asc');
                                                                    } else { setsortType('policy_status+asc'); }
                                                                    setCurrentPage(1);
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Start Date
                                                        <a href="javascript:void(0)" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'start_date+asc' ? 180 : 0,
                                                                }}
                                                                src="/images/sort.svg"
                                                                // className={`${sortType === 'start_date' ? 'image-rotate' : ''}`}
                                                                alt="icon"
                                                                onClick={() => {
                                                                // handleSort('start_date');
                                                                    if (sortType === 'start_date+asc') {
                                                                        setsortType('start_date+desc');
                                                                    } else if (sortType === 'start_date+desc') {
                                                                        setsortType('start_date+asc');
                                                                    } else { setsortType('start_date+asc'); }
                                                                    setCurrentPage(1);
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="pt-4 px-7  min-w-[152px] flex justify-center">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        End Date
                                                        <a href="javascript:void(0)" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'end_date+asc' ? 180 : 0,
                                                                }}
                                                                src="/images/sort.svg"
                                                                // className={`${sortType === 'end_date' ? 'image-rotate' : ''}`}
                                                                alt="icon"
                                                                onClick={() => {
                                                                // handleSort('end_date');
                                                                    if (sortType === 'end_date+asc') {
                                                                        setsortType('end_date+desc');
                                                                    } else if (sortType === 'end_date+desc') {
                                                                        setsortType('end_date+asc');
                                                                    } else { setsortType('end_date+asc'); }
                                                                    setCurrentPage(1);
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 rounded-tr-lg rounded-br-lg min-w-[100px] sticky top-0 right-0 bg-[#555259]" />
                                            </tr>
                                        </motion.thead>
                                        <>
                                            <ListDap
                                                setisPaneOpen={setisPaneOpen}
                                                getUserList={getDAPList}
                                                DAPList={DAPList}
                                                setisLoaded={setisLoaded}
                                                currentPage={currentPage}
                                                totalPage={totalPage}
                                                setCurrentPage={setCurrentPage}
                                                setrender={setrender}
                                                setEditDAte={setEditDAte}
                                                render={render}
                                                seteditpaneopen={seteditpaneopen}
                                                EditDAte={EditDAte}
                                                // handleSort={handleSort}
                                                setsort={setsort}
                                                sort={sort}
                                                setsortType={setsortType}
                                                filter={filter}
                                                OpenPopup={OpenPopup}
                                                setOpenPopup={setOpenPopup}
                                                handleActivateOrDeactivate={handleActivateOrDeactivate}
                                                actvloader={actvloader}
                                                setactvloader={setactvloader}
                                                isEditId={isEditId}
                                                setisEditId={setisEditId}
                                                isLoaded={isLoaded}
                                                viewdapprevilegeassigned={viewdapprevilegeassigned}
                                                updatedapprevilegeassigned={updatedapprevilegeassigned}
                                                activatedeactivedapprevilegeassigned={activatedeactivedapprevilegeassigned}
                                            />

                                        </>

                                    </table>
                                )}

                            {DAPList?.list && DAPList?.list.length === 0 && (
                                <EmptyScreen
                                    text="no DAP Policies"
                                    url="/manage-freight-policy/create-new-dap"
                                    action="Create DAP"
                                    // title="Freight Policy (DAP)"
                                    search={searchValue}
                                />
                            )}

                        </>
                    ) : <ItemSkeleton />}
            </div>

            <SlidingPane
                from="right"
                isOpen={filter}
                width="30%"
                className="z-50"
                hideHeader
                onRequestClose={() => setfilter(false)}

            >
                <FilterModal
                    filter={filter}
                    setfilter={setfilter}
                    threePL={threePL}
                    territaryList={territaryList}
                    handleFiletr={handleFiletr}
                    selected={selected}
                    setselected={setselected}
                />

            </SlidingPane>
            { DAPList.list && Object.keys(DAPList.list).length > 0 && handlePage() && (
                <Pagination handlePageClick={handlePageClick} List={DAPList} currentPage={currentPage} />
            )}
        </>
    );
}
const mapState = (state) => {
    const { DAPList } = state;
    return { DAPList };
};
const createActors = {
    getDAPList: DApActions.DAPList,
};
const connectAdminUsers = connect(mapState, createActors)(ManageDap);

export { connectAdminUsers as ManageDap };
